import {Component, computed, input} from '@angular/core';
import {CurrencyPipe, NgClass} from '@angular/common';

@Component({
  selector: 'ta-cost-bubble',
  imports: [
    CurrencyPipe,
    NgClass
  ],
  templateUrl: './ta-cost-bubble.component.html',
  styleUrl: './ta-cost-bubble.component.scss'
})
export class TaCostBubbleComponent {
  value = input<number>(0);
  title = input<string>();
  subtitle = input<string>();
  // Font Awesome classes for an icon before the title.
  titleIcon = input<string>();
  severity = input<'outlined' | 'primary' | 'dark' | 'text' | 'success' | 'purple' | 'danger' >();
  disabled = input<boolean>(false);
  tableVersion = input<boolean>(false);
  // Show +/- and print the magnitude.
  signed = input<boolean>(false);
  displayValue = computed(() => this.signed() ? Math.abs(this.value()) : this.value());
  chipClass = computed<string>(() => {
    let chipClassStr = '';
    if (this.severity() === 'primary') {
      chipClassStr = 'bg-primary-600 text-white ';
      if (this.tableVersion()) {
        chipClassStr += " font-bold"
      } else {
        chipClassStr += " font-semibold"
      }
    } else if (this.severity() === 'dark') {
      chipClassStr = 'bg-primary-800 text-white ';
    } else if (this.severity() === 'outlined') {
      chipClassStr = 'bg-surface-100 border border-surface-700 text-surface-800';
    } else if (this.severity() === 'success') {
      chipClassStr = 'bg-green-100 border border-surface-700 text-surface-800';
    } else if (this.severity() === 'purple') {
      chipClassStr = 'bg-purple-100 border border-surface-700 text-surface-800';
    } else if (this.severity() === 'danger') {
      chipClassStr = 'bg-red-200 border border-surface-700 text-surface-800';
    } else {//text is default option
      chipClassStr = 'bg-surface-100 text-surface-800';
    }
    if (this.tableVersion()) {
      chipClassStr += " font-[\'Roboto_Condensed\']"
    } else {
      chipClassStr += " font-[\'Inter\']"
    }
    return chipClassStr;
  })
}
